module.exports = __webpack_public_path__ + "static/media/icon_pdf.fcfcdb29.svg";